import React from 'react';
import ReactMarkdown from 'react-markdown';

const SimpleMarkdownDisplay = ({ content, className = '' }) => {
  return (
    <div className={`markdown-content ${className}`}>
      <ReactMarkdown
        components={{
          code({ node, inline, className, children, ...props }) {
            return (
              <code 
                className={className} 
                style={{
                  backgroundColor: '#f5f5f5',
                  padding: inline ? '2px 4px' : '8px 12px',
                  borderRadius: '3px',
                  fontFamily: 'Courier New, monospace',
                  fontSize: '13px',
                  display: inline ? 'inline' : 'block',
                  whiteSpace: 'pre-wrap',
                  overflow: 'auto'
                }}
                {...props}
              >
                {children}
              </code>
            );
          },
          h1: ({ children }) => (
            <h1 style={{ 
              fontSize: '1.5em', 
              fontWeight: 'bold', 
              margin: '16px 0 8px 0',
              color: '#0e4410'
            }}>
              {children}
            </h1>
          ),
          h2: ({ children }) => (
            <h2 style={{ 
              fontSize: '1.3em', 
              fontWeight: 'bold', 
              margin: '14px 0 6px 0',
              color: '#0e4410'
            }}>
              {children}
            </h2>
          ),
          h3: ({ children }) => (
            <h3 style={{ 
              fontSize: '1.1em', 
              fontWeight: 'bold', 
              margin: '12px 0 4px 0',
              color: '#0e4410'
            }}>
              {children}
            </h3>
          ),
          p: ({ children }) => (
            <p style={{ 
              margin: '8px 0', 
              lineHeight: '1.6',
              color: '#343541'
            }}>
              {children}
            </p>
          ),
          ul: ({ children }) => (
            <ul style={{ 
              margin: '8px 0', 
              paddingLeft: '20px',
              color: '#343541'
            }}>
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol style={{ 
              margin: '8px 0', 
              paddingLeft: '20px',
              color: '#343541'
            }}>
              {children}
            </ol>
          ),
          li: ({ children }) => (
            <li style={{ 
              margin: '4px 0',
              lineHeight: '1.5'
            }}>
              {children}
            </li>
          ),
          strong: ({ children }) => (
            <strong style={{ 
              fontWeight: 'bold',
              color: '#0e4410'
            }}>
              {children}
            </strong>
          ),
          em: ({ children }) => (
            <em style={{ 
              fontStyle: 'italic',
              color: '#4caf50'
            }}>
              {children}
            </em>
          ),
          blockquote: ({ children }) => (
            <blockquote style={{ 
              borderLeft: '4px solid #4caf50',
              margin: '12px 0',
              padding: '8px 16px',
              backgroundColor: '#f7f7f8',
              fontStyle: 'italic'
            }}>
              {children}
            </blockquote>
          ),
          hr: () => (
            <hr style={{ 
              border: 'none',
              borderTop: '1px solid #eee',
              margin: '16px 0'
            }} />
          ),
          table: ({ children }) => (
            <table style={{ 
              borderCollapse: 'collapse',
              width: '100%',
              margin: '12px 0',
              border: '1px solid #eee'
            }}>
              {children}
            </table>
          ),
          th: ({ children }) => (
            <th style={{ 
              border: '1px solid #eee',
              padding: '8px 12px',
              backgroundColor: '#f7f7f8',
              fontWeight: 'bold',
              textAlign: 'left'
            }}>
              {children}
            </th>
          ),
          td: ({ children }) => (
            <td style={{ 
              border: '1px solid #eee',
              padding: '8px 12px'
            }}>
              {children}
            </td>
          )
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default SimpleMarkdownDisplay;
